<script>
	const { events } = require('utilities/analyticsUtilities');
	const { assetUrl } = require('utilities/urlUtilities');

	export default {
		components: {
			'audio-player-simple': require('components/audio-player-simple.vue').default,
			'draggable-popup': require('components/draggable-popup.vue').default,
			'vocab-entry': require('components/vocab-entry.vue').default,
			'vocab-powered-by-wordsmyth': require('components/vocab-powered-by-wordsmyth.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default
		},
		props: {
			article: {
				type: Object,
				required: true
			},
			senseId: {
				required: true
			},
			occurrenceId: {
				required: true
			},
			eventData: {
				required: false,
				default: function () {
					return {
						parentPid: null,
						assignmentId: null
					};
				}
			}
		},
		data() {
			return {
				baseX: 0,
				baseY: 0,
				events
			};
		},
		computed: {
			closeImgSrc() {
				return assetUrl('/assets/dist/images/wordsmyth/close_btn.gif');
			}
		},
		methods: {
			open(aroundElement, label) {
				this.$refs.popup.open(aroundElement, label);
			},
			close() {
				this.$refs.popup.close();
				this.$emit('close');
			}
		}
	};
</script>
<template>
	<div class="vocab-popup print-hidden">
		<draggable-popup ref="popup">
			<div class="vocab-popup-content">
				<div class="entry_container json_data">
					<button
						class="close-btn button -link tooltip-bottom"
						@click.prevent="close">
						<img
							:src="closeImgSrc"
							alt="Close" />
					</button>
					<vocab-entry
						show-audio
						:article="article"
						:sense-id="senseId"
						:occurrence-id="occurrenceId"
						:event-data="eventData"></vocab-entry>
				</div>
			</div>

			<vocab-powered-by-wordsmyth></vocab-powered-by-wordsmyth>
		</draggable-popup>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.vocab-popup > .draggable-popup {
		width: 600px;
		padding: 8px 20px 8px 8px;
		height: auto;
		border: 2px solid #99d5d2;
		border-radius: 8px;
		line-height: 100%;
	}

	.vocab-popup-content {
		.close-btn {
			position: absolute;
			right: 10px;
			top: 10px;
		}

		overflow: auto;
		max-height: calc(70vh - 48px);

		div.entry_container {
			padding: 1em;
		}

		div.headword_block {
			margin-bottom: 2em;
		}

		span.headword {
			font-size: 150%;
			font-weight: 700;
			color: $c-blue;
		}

		div.pos_block {
			background-color: #f6f3a6;
		}

		div.level_map_container div.entry_container {
			display: none;
		}

		div.entry_container.rwr,
		span.level_control.rwr {
			background-color: #d5eef9;
		}

		span.occurrence {
			text-decoration: underline;
			background-color: #f2f2f2;
		}

		div.entry_container.json_data {
			padding-left: 1.5em;
			padding-right: 2em;
		}

		div.entry_container.json_data div.headword_block {
			margin-bottom: 0;
		}

		div.entry_container.json_data div.pos_block {
			background-color: white;
			margin-top: 0.3em;
			padding-bottom: 0.3em;
		}

		div.entry_container.json_data span.pos_title {
			display: none;
		}

		div.entry_container.json_data span.pos_value {
			color: $c-blue-dark;
		}

		div.entry_container.json_data span.pos_title {
			padding-left: 0;
			padding-right: 0.5em;
			min-width: 4.5em;
		}
	}

	.vocab-popup > .draggable-popup.mobile-full-screen {
		.vocab-popup-content {
			padding-bottom: 60px;
			max-height: none;
			height: calc(100% - 40px);
		}

		height: auto;
		bottom: 2vh;
	}
</style>
